import { RestaurantHours } from "./RestaurantHours";

export default RestaurantHours;
